<template>
    <li class="tyn-appbar-item">
        <a class="tyn-appbar-link dropdown-toggle position-relative" data-bs-toggle="dropdown" href="#" data-bs-offset="0,10" data-bs-auto-close="outside">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-app-indicator" viewBox="0 0 16 16">
                <path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1z" />
                <path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
            </svg><!-- app-indicator -->
            <div class="badge bg-primary position-absolute rounded-pill top-0 end-0 mt-n1 me-n1"
                 v-if="notificacoesNaoVistasVisuais.length > 0">
                {{notificacoesNaoVistasVisuais.length}}
            </div>
            <span class="d-none">Notifications</span>
        </a><!-- .dropdown-toggle -->
        <div class="dropdown-menu dropdown-menu-rg dropdown-menu-end">
            <div class="dropdown-head">
                <div class="title title-with-divider">
                    <h6 class="dropdown-title">Notificações</h6>
                </div>
                <ul class="nav nav-tabs modern-tabs" role="tablist">
                    <li class="nav-item">
                        <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#notifications-unread" type="button" role="tab"> Não lidas </button>
                    </li>
                    <li class="nav-item">
                        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#notifications-all" type="button" role="tab"> Todas </button>
                    </li>
                </ul>
            </div><!-- .dropdown-head -->
            <div class="dropdown-gap">
                
                <div class="tab-content tab-notificacoes">
                    <div class="tab-pane show active" id="notifications-unread" tabindex="0">
                        <button v-if="lstNotificacoes.length > 0" class="btn btn-primary btn-sm d-flex mb-2" @click="marcaVistoTodos" style="padding: .25rem .5rem; font-size: .75rem; justify-self: center;">
                            Marcar todas como lidas</button>
                        <ul class="tyn-media-list gap gap-3">
                            <template v-if="lstNotificacoes.length > 0">
                                <li v-for="(item, index) in lstNotificacoes" :key="index" class="c-pointer" @click="toggleExpand(item.idNotificacao)">
                                    <div class="tyn-media-group">
                                        <div class="tyn-media tyn-circle">
                                            <img :src="item.urlImagem" alt="">
                                        </div>
                                        <div class="tyn-media-col">
                                            <div class="tyn-media-row">
                                                <span class="message">
                                                    <strong>{{item.nmUsuario}}</strong>
                                                    <small v-if="item.dtNotificacao"> - {{item.dtNotificacao}}</small>
                                                </span>
                                            </div>
                                            <div class="tyn-media-row d-flex justify-content-between align-items-center">
                                                <span class="meta" style="white-space: normal;">
                                                    {{item.dsTitulo}}
                                                </span>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor"
                                                     class="bi bi-chevron-down ms-2 transition-icon"
                                                     :class="{'rotated': expandedNotificacoes[item.idNotificacao]}"
                                                     viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                                </svg>
                                            </div>

                                            <transition name="accordion">
                                                <div v-show="expandedNotificacoes[item.idNotificacao]" class="tyn-media-row accordion-body">
                                                    <span class="meta text-muted" style="white-space: normal;">
                                                        {{item.dsNotificacao}}
                                                    </span>
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                </li>

                            </template>
                            <template v-else>
                                <li class="empty-state">
                                    <div class="empty-state-card">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z" />
                                        </svg>
                                        <span>Nenhum registro encontrado.</span>
                                    </div>
                                </li>
                            </template>

                        </ul><!-- .tyn-media-list -->
                    </div>
                </div>
                <div class="tab-content tab-notificacoes">
                    <div class="tab-pane" id="notifications-all" tabindex="0">
                        <ul class="tyn-media-list gap gap-3">
                            <template v-if="lstTodas.length > 0">
                                <li v-for="(item, index) in lstTodas" :key="index" class="c-pointer" @click="toggleExpand(item.idNotificacao)">
                                    <div class="tyn-media-group">
                                        <div class="tyn-media tyn-circle">
                                            <img :src="item.urlImagem" alt="">
                                        </div>
                                        <div class="tyn-media-col">
                                            <div class="tyn-media-row">
                                                <span class="message">
                                                    <strong>{{item.nmUsuario}}</strong>
                                                    <small v-if="item.dtNotificacao"> - {{item.dtNotificacao}}</small>
                                                </span>
                                            </div>
                                            <div class="tyn-media-row d-flex justify-content-between align-items-center">
                                                <span class="meta" style="white-space: normal;">
                                                    {{item.dsTitulo}}
                                                </span>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor"
                                                     class="bi bi-chevron-down ms-2 transition-icon"
                                                     :class="{'rotated': expandedNotificacoes[item.idNotificacao]}"
                                                     viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                                </svg>
                                            </div>
                                            <transition name="accordion">
                                                <div v-show="expandedNotificacoes[item.idNotificacao]" class="tyn-media-row accordion-body">
                                                    <span class="meta text-muted" style="white-space: normal;">
                                                        {{item.dsNotificacao}}
                                                    </span>
                                                </div>
                                            </transition>
                                        </div>
                                    </div>
                                </li>

                            </template>
                            <template v-else>
                                <li class="empty-state">
                                    <div class="empty-state-card">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                            <path d="M6.002 5.5a1 1 0 1 1 2 0v3.25a1 1 0 0 1-2 0zM8 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                                        </svg>
                                        <span>Nenhum registro encontrado.</span>
                                    </div>
                                </li>
                            </template>

                        </ul><!-- .tyn-media-list -->
                    </div>
                </div>

            </div><!-- .dropdown-gap -->
        </div><!-- .dropdown-menu -->
    </li><!-- .tyn-appbar-item -->
</template>

<script>
    
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'NotificacoesHeader',
        components: { },
        computed: {
            hubConection() {
                return this.$store.state.hubConection
            },
            lstNormas() {
                return this.$store.state.lstNormas
            },
            notificacoesNaoVistasVisuais() {
                return this.lstNotificacoes.filter(
                    n => !this.notificacoesRecemVistas.includes(n.idNotificacao)
                );
            }
        },
        data: function () {
            return {
                lstNotificacoes: [],
                expandedNotificacoes: {},
                notificacoesRecemVistas: [],
                lstTodas: [],
            }
        },
        methods: {
            InitSignalR() {
                try {
                    let $this = this;
                    $this.hubConection.on("AtualizaStatusNorma", function (idNorma, status) {
                        if (status !== 'Erro') {
                            let norma = $this.lstNormas.find(x => x.idNorma == idNorma);

                            if (norma) {
                                avisoToast('Status da normativa "' + (norma.dsNome || norma.nmNorma || norma.nmArquivo || 'Normativa') + '" atualizado para "' + status + '"')
                            } else {
                                avisoToast('Status da normativa atualizado para "' + status + '"')
                            }
                        }
                        $this.$store.commit('setNormativas');
                    });

                    $this.hubConection.on("NovaNotificacao", function (status, dtAtualizacao) {
                        avisoToast('' + status + ' - ' + moment(dtAtualizacao, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY [às] HH:mm'));
                        $this.load();
                    });

                    let rota = this.$route.name.split('-')[0];

                    

                    if (rota != 'Consulta') {
                        $this.hubConection.on("RecebeNotificacao", function (idConversa, status, dtAtualizacao) {
                            avisoToast('Status da pergunta atualizado para ' + status + ' - ' + moment(dtAtualizacao, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY [às] HH:mm'));
                        });
                    }
                    if (rota != 'Artefato') {
                        $this.hubConection.on("RecebeNotificacaoArtefato", function (idArtefato, status, dtAtualizacao) {
                            avisoToast('Status do artefato atualizado para ' + status + ' - ' + moment(dtAtualizacao, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY [às] HH:mm'));
                        });
                    }
                    
                    if (rota != 'Research') {
                        $this.hubConection.on("RecebeNotificacaoResearch", function (idResearch, status, dtAtualizacao) {
                            avisoToast('Status da research atualizado para ' + status + ' - ' + moment(dtAtualizacao, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY [às] HH:mm'));
                        });
                    }
                    
                    if (rota != 'Processo') {
                        $this.hubConection.on("RecebeNotificacaoProcessoConversa", function (idProcessoPergunta, status, dtAtualizacao) {
                            avisoToast('Status da pergunta do processo atualizado para ' + status + ' - ' + moment(dtAtualizacao, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY [às] HH:mm'));
                        });
                    }
                }
                catch (ex) {
                    console.log(ex);
                }
            },

            load() {
                this.lstNotificacoes = [];

                this.lstTodas = [];
                this.lstTodas.push({
                    idNotificacao: 0, urlImagem: "/assets/images/sollai/avatar.png", nmUsuario: "SollAi", dsTitulo: "Olá! Aqui é a SollAi. Como você pode ver, fui atualizada. Na sua primeira utilização após a atualização, por favor, envie uma pergunta na Consulta Inteligente. Caso minha resposta não esteja precisa, repita a mesma pergunta para me ajudar a calibrar as respostas.",
                    dtNotificacao: null });

                this.getNotificacoes();
            },

            getNotificacoes() {
                let $this = this;
                axios.get(`${urlApi}/Notificacao/Get`, { showLoading: false, params: { index: 0, take: 50 } })
                    .then(res => {
                        if (res.data.success) {
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                var item = res.data.data.rows[i];
                                item.dtInclusao = moment(item.dtInclusao).format('DD/MM/YYYY [às] HH:mm');

                                const notificacao = {
                                    idNotificacao: item.idNotificacao,
                                    urlImagem: "/assets/images/sollai/avatar.png",
                                    nmUsuario: "SollAi",
                                    dsTitulo: item.dsTitulo,
                                    dsNotificacao: item.dsNotificacao ?? '',
                                    dtNotificacao: item.dtInclusao
                                };

                                if (!item.flVisto) {
                                    $this.lstNotificacoes.push(notificacao);
                                }

                                $this.lstTodas.push(notificacao);
                            }
                        } else {
                            avisoErro("Não foi possível carregar suas notificações.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar suas notificações.");
                        }
                    });
            },

            toggleExpand(id) {
                const wasExpanded = this.expandedNotificacoes[id];
                this.$set(this.expandedNotificacoes, id, !wasExpanded);

                if (!wasExpanded) {
                    this.marcaVisto(id);
                }
            },

            marcaVisto(idNotificacao) {
                if (idNotificacao != 0 && !this.notificacoesRecemVistas.includes(idNotificacao)) {
                    axios.post(`${urlApi}/Notificacao/MarcarVisto`, { idNotificacao }, { showLoading: false })
                        .then(() => {
                            this.notificacoesRecemVistas.push(idNotificacao);
                        })
                        .catch(() => {
                            console.log("Não foi possível marcar como visto.");
                        });
                }
            },

            marcaVistoTodos() {
                axios.post(`${urlApi}/Notificacao/MarcarVistoTodos`, {}, { showLoading: true })
                    .then(() => {
                        this.load();
                    })
                    .catch(() => {
                        console.log("Não foi possível marcar como visto.");
                    });
            },
            removeRecemVistas() {
                this.lstNotificacoes = this.lstNotificacoes.filter(
                    n => !this.notificacoesRecemVistas.includes(n.idNotificacao)
                );
                this.notificacoesRecemVistas = [];
            }

            
        },
        mounted: function() {
            if (this.hubConection != undefined) {
                this.InitSignalR();
            }

            this.load();

            // Escutar o fechamento do dropdown
            const dropdown = document.querySelector('.tyn-appbar-link[data-bs-toggle="dropdown"]');
            if (dropdown) {
                dropdown.addEventListener('hide.bs.dropdown', () => {
                    this.removeRecemVistas();
                });
            }
        }

    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .dropdown-menu{
        max-width: 380px !important;
        width: 100%;
    }

    li.c-pointer {
        cursor: pointer;
    }
    .transition-icon {
        transition: transform 0.3s ease;
    }

    .transition-icon.rotated {
        transform: rotate(180deg);
    }

    .accordion-body {
        overflow: hidden;
    }

    .accordion-enter-from, .accordion-leave-to {
        max-height: 0;
        opacity: 0;
    }

    .accordion-enter-to, .accordion-leave-from {
        max-height: 300px; 
        opacity: 1;
    }

    .tyn-media-list {
        display: flex;
        flex-direction: column;
        gap: 0.65rem;
        padding: 0 1rem 1.1rem;
    }

    .tyn-media-list > li {
        list-style: none;
    }

    .tyn-media-group {
        border: 1px solid rgba(226, 232, 240, 0.9);
        border-radius: 14px;
        padding: 0.8rem 0.9rem;
        display: flex;
        gap: 0.7rem;
        align-items: flex-start;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
        /*transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;*/
    }

    .tyn-media-group:hover {
        transform: translateY(-1px);
        box-shadow: 0 10px 20px rgba(15, 23, 42, 0.08);
        border-color: rgba(148, 163, 184, 0.6);
    }

    .toggler-enter-active, .toggler-leave-active {
        transition: all 0.3s ease;
    }

    .toggler-enter-from, .toggler-leave-to {
        opacity: 0;
        max-height: 0;
    }

    .dropdown-head {
        padding: 1.1rem 1.2rem 0.8rem;
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        gap: 1rem;
        flex-wrap: wrap;
    }

    .dropdown-title {
        margin: 0;
        font-size: 1rem;
        font-weight: 700;
        color: #0f172a;
        position: relative;
        padding-bottom: 0.7rem;
    }

    .dropdown-title::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 2px;
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.45), transparent);
    }

    .modern-tabs {
        display: flex;
        gap: 0.35rem;
        border-bottom: none;
        background: linear-gradient(135deg, rgba(248, 250, 252, 0.95) 0%, rgba(237, 242, 247, 0.9) 100%);
        border-radius: 12px;
        padding: 0.45rem 0.55rem;
        box-shadow: inset 0 0 0 1px rgba(226, 232, 240, 0.55);
    }

    .modern-tabs .nav-link {
        border: 1px solid transparent;
        background: rgba(248, 250, 252, 0.8);
        color: #475569;
        font-weight: 600;
        font-size: 0.78rem;
        padding: 0.45rem 1.05rem;
        border-radius: 999px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 0.35rem;
        transition: all 0.2s ease;
        box-shadow: inset 0 0 0 1px rgba(226, 232, 240, 0.65);
    }

    .modern-tabs .nav-link:hover {
        background: rgba(37, 99, 235, 0.08);
        color: #2563EB;
        box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.25);
    }

    .modern-tabs .nav-link.active {
        background: linear-gradient(135deg, #2563EB 0%, #22c55e 100%);
        color: #ffffff;
        box-shadow: 0 6px 18px rgba(37, 99, 235, 0.22);
        border: none;
    }

    .modern-tabs .nav-link.disabled,
    .modern-tabs .nav-link:disabled {
        opacity: 0.55;
        cursor: not-allowed !important;
        pointer-events: auto;
    }

    :deep([data-bs-theme="dark"]) .dropdown-title {
        color: #e2e8f0;
    }

    :deep([data-bs-theme="dark"]) .dropdown-title::after {
        background: linear-gradient(90deg, transparent, rgba(71, 85, 105, 0.55), transparent);
    }

    :deep([data-bs-theme="dark"]) .modern-tabs {
        background: linear-gradient(135deg, rgba(30, 41, 59, 0.95) 0%, rgba(15, 23, 42, 0.92) 100%);
        box-shadow: inset 0 0 0 1px rgba(71, 85, 105, 0.45);
    }

    :deep([data-bs-theme="dark"]) .modern-tabs .nav-link {
        background: rgba(30, 41, 59, 0.88);
        color: #cbd5f5;
        box-shadow: inset 0 0 0 1px rgba(71, 85, 105, 0.4);
    }

    :deep([data-bs-theme="dark"]) .modern-tabs .nav-link:hover {
        background: rgba(59, 130, 246, 0.2);
        color: #93c5fd;
        box-shadow: inset 0 0 0 1px rgba(59, 130, 246, 0.3);
    }

    :deep([data-bs-theme="dark"]) .modern-tabs .nav-link.active {
        background: linear-gradient(135deg, #2563EB 0%, #16a34a 100%);
        box-shadow: 0 10px 24px rgba(37, 99, 235, 0.3);
    }

    .tyn-media{
        width: 36px;
        height: 36px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #edf2f7;
        overflow: hidden;
        flex-shrink: 0;
    }

    .tyn-media img {
        width: 32px;
        height: 32px;
        object-fit: cover;
    }

    .tyn-media-col {
        display: flex;
        flex-direction: column;
        gap: 0.35rem;
        width: 100%;
        min-width: 0;
        flex: 1;
    }

    .tyn-media-col .tyn-media-row {
        max-width: 100%;
        width: 100%;
    }

    .tyn-media-row .message {
        font-weight: 600;
        color: #1e293b;
        display: inline-flex;
        gap: 0.25rem;
        align-items: baseline;
        flex-wrap: wrap;
        word-break: break-word;
    }

    .tyn-media-row .message small {
        color: #64748b;
        font-weight: 500;
        white-space: nowrap;
    }

    .tyn-media-row .meta {
        color: #334155;
        line-height: 1.4;
        word-break: break-word;
        overflow-wrap: break-word;
    }

    .tyn-media-row svg {
        color: #94a3b8;
        flex-shrink: 0;
    }

    .accordion-body {
        background: rgba(248, 250, 252, 0.92);
        border-radius: 10px;
        padding: 0.65rem 0.75rem;
        border: 1px solid rgba(226, 232, 240, 0.8);
        color: #1f2937;
    }

    .accordion-body .meta {
        color: #1f2937;
        font-weight: 500;
    }

    .empty-state {
        list-style: none;
    }

    .empty-state-card {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.5rem;
        padding: 0.85rem;
        border-radius: 12px;
        border: 1px dashed rgba(148, 163, 184, 0.6);
        color: #475569;
        font-size: 0.9rem;
        background: rgba(248, 250, 252, 0.85);
    }

    .tab-notificacoes {
        max-height: 30vh;
        overflow: auto;
    }

    /* Responsivo - Tablet */
    @media (max-width: 768px) {
        .dropdown-menu {
            max-width: calc(100vw - 2rem) !important;
            margin: 0 1rem;
        }

        .dropdown-head {
            padding: 0.9rem 1rem 0.7rem;
            gap: 0.8rem;
        }

        .dropdown-title {
            font-size: 0.95rem;
            padding-bottom: 0.6rem;
        }

        .modern-tabs {
            padding: 0.4rem 0.5rem;
            gap: 0.3rem;
        }

        .modern-tabs .nav-link {
            font-size: 0.75rem;
            padding: 0.4rem 0.9rem;
        }

        .tyn-media-list {
            padding: 0 0.9rem 1rem;
            gap: 0.6rem;
        }

        .tyn-media-group {
            padding: 0.7rem 0.8rem;
            gap: 0.6rem;
        }

        .tyn-media {
            width: 34px;
            height: 34px;
        }

        .tyn-media img {
            width: 30px;
            height: 30px;
        }

        .tab-notificacoes {
            max-height: 35vh;
        }
    }

    /* Responsivo - Mobile */
    @media (max-width: 480px) {
        .dropdown-menu {
            max-width: calc(100vw - 1rem) !important;
            margin: 0 0.5rem;
            left: auto !important;
            right: 0.5rem !important;
        }

        .dropdown-head {
            padding: 0.8rem 0.9rem 0.6rem;
            align-items: stretch;
            flex-direction: column;
            gap: 0.7rem;
        }

        .dropdown-title {
            font-size: 0.9rem;
            padding-bottom: 0.5rem;
        }

        .title-with-divider {
            width: 100%;
        }

        .modern-tabs {
            width: 100%;
            justify-content: space-between;
            padding: 0.35rem 0.4rem;
            gap: 0.25rem;
        }

        .modern-tabs .nav-link {
            font-size: 0.7rem;
            padding: 0.35rem 0.75rem;
            flex: 1;
            min-width: 0;
        }

        .tyn-media-list {
            padding: 0 0.75rem 0.9rem;
            gap: 0.55rem;
        }

        .tyn-media-group {
            padding: 0.65rem 0.7rem;
            gap: 0.55rem;
            border-radius: 12px;
        }

        .tyn-media {
            width: 32px;
            height: 32px;
        }

        .tyn-media img {
            width: 28px;
            height: 28px;
        }

        .tyn-media-col {
            gap: 0.3rem;
        }

        .tyn-media-row .message {
            font-size: 0.85rem;
        }

        .tyn-media-row .message small {
            font-size: 0.75rem;
        }

        .tyn-media-row .meta {
            font-size: 0.85rem;
        }

        .tyn-media-row svg {
            width: 10px;
            height: 10px;
        }

        .accordion-body {
            padding: 0.55rem 0.65rem;
            border-radius: 8px;
        }

        .accordion-body .meta {
            font-size: 0.8rem;
        }

        .empty-state-card {
            padding: 0.7rem;
            font-size: 0.85rem;
            gap: 0.4rem;
        }

        .empty-state-card svg {
            width: 16px;
            height: 16px;
        }

        .tab-notificacoes {
            max-height: 40vh;
        }
    }

    /* Responsivo - Mobile Pequeno */
    @media (max-width: 360px) {
        .dropdown-menu {
            max-width: calc(100vw - 0.5rem) !important;
            margin: 0 0.25rem;
            right: 0.25rem !important;
        }

        .dropdown-head {
            padding: 0.7rem 0.75rem 0.55rem;
        }

        .dropdown-title {
            font-size: 0.85rem;
        }

        .modern-tabs .nav-link {
            font-size: 0.65rem;
            padding: 0.3rem 0.6rem;
        }

        .tyn-media-list {
            padding: 0 0.65rem 0.8rem;
        }

        .tyn-media-group {
            padding: 0.6rem 0.65rem;
        }

        .tyn-media {
            width: 30px;
            height: 30px;
        }

        .tyn-media img {
            width: 26px;
            height: 26px;
        }
    }

    :deep([data-bs-theme="dark"]) .tyn-media-group {
        background: rgba(30, 41, 59, 0.92);
        border-color: rgba(51, 65, 85, 0.85);
        box-shadow: 0 6px 18px rgba(2, 6, 23, 0.68);
    }

    :deep([data-bs-theme="dark"]) .tyn-media-group:hover {
        border-color: rgba(59, 130, 246, 0.35);
        box-shadow: 0 10px 26px rgba(37, 99, 235, 0.22);
    }

    :deep([data-bs-theme="dark"]) .tyn-media {
        background: rgba(30, 41, 59, 0.85);
    }

    :deep([data-bs-theme="dark"]) .tyn-media-row .message {
        color: #e2e8f0;
    }

    :deep([data-bs-theme="dark"]) .tyn-media-row .message small {
        color: #94a3b8;
    }

    :deep([data-bs-theme="dark"]) .tyn-media-row .meta {
        color: #cbd5f5;
    }

    :deep([data-bs-theme="dark"]) .accordion-body {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(71, 85, 105, 0.65);
        color: #e2e8f0 !important;
    }

    :deep([data-bs-theme="dark"]) .accordion-body .meta {
        color: #e2e8f0;
    }

    :deep([data-bs-theme="dark"]) .tyn-media-row svg {
        color: #64748b;
    }

    :deep([data-bs-theme="dark"]) .empty-state-card {
        background: rgba(30, 41, 59, 0.85);
        border-color: rgba(71, 85, 105, 0.7);
        color: #cbd5f5;
    }
</style>

